// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2b9_v","row":"Node_row__tZjki","label":"Node_label__3nuo7","footer":"Node_footer__eh9Vi"};